import request from "@/utils/request";
export const getBasicInfo = () => {
    return request.get("/basic/info");
};
export const updateBasicInfo = (data) => {
    return request.put("/basic/info", data);
};
